import { render, staticRenderFns } from "./CommitteesSidebar.vue?vue&type=template&id=7b9f08bc&scoped=true"
import script from "./CommitteesSidebar.vue?vue&type=script&lang=js"
export * from "./CommitteesSidebar.vue?vue&type=script&lang=js"
import style0 from "./CommitteesSidebar.vue?vue&type=style&index=0&id=7b9f08bc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b9f08bc",
  null
  
)

export default component.exports